module.exports = __webpack_public_path__ + "img/love-paws-homestay-logo-burgundy.fc8a11e5.png";